/* =========================================
   CHEWLAX - THEME JS
   Homepage sliders, quick add, variant sync
   ========================================= */

(function () {
  'use strict';

  document.documentElement.classList.remove('no-js');

  var lastFocusedBeforeDrawer = null;

  function toArray(nodeList) {
    return Array.prototype.slice.call(nodeList || []);
  }

  function parseJSON(value, fallback) {
    try {
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  }

  function escapeHTML(value) {
    return String(value || '').replace(/[&<>"']/g, function (char) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[char];
    });
  }

  function formatMoney(cents) {
    var amount = (parseInt(cents, 10) || 0) / 100;
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD'
      }).format(amount);
    } catch (e) {
      return '$' + amount.toFixed(2);
    }
  }

  function initReveal() {
    var els = toArray(document.querySelectorAll('.reveal, .reveal-scale, .reveal-up'));
    if (!els.length) return;

    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function (el) { io.observe(el); });
  }

  function initHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;
    var announcement = document.querySelector('.announcement-bar');

    function syncOffsets() {
      var offsetTop = announcement ? announcement.offsetHeight : 0;
      header.style.top = offsetTop + 'px';
      document.documentElement.style.setProperty('--header-offset', (header.offsetHeight + offsetTop) + 'px');
    }

    function onScroll() {
      var y = window.scrollY || window.pageYOffset;
      header.classList.toggle('is-scrolled', y > 18);
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', syncOffsets);
    syncOffsets();
    onScroll();
  }

  function initMobileMenu() {
    var toggle = document.querySelector('.mobile-menu-toggle');
    var menu = document.querySelector('.mobile-menu');
    var close = document.querySelector('.mobile-menu-close');
    if (!toggle || !menu) return;

    function open() {
      menu.classList.add('is-open');
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function shut() {
      menu.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    }

    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);

    toArray(menu.querySelectorAll('a')).forEach(function (link) {
      link.addEventListener('click', shut);
    });
  }

  function initFAQ() {
    toArray(document.querySelectorAll('.faq-question')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.faq-item');
        if (!item) return;

        var answer = item.querySelector('.faq-answer');
        var inner = item.querySelector('.faq-answer-inner');
        var isOpen = item.classList.contains('is-open');

        var parent = item.parentNode;
        if (parent) {
          toArray(parent.querySelectorAll('.faq-item.is-open')).forEach(function (openItem) {
            if (openItem === item) return;
            openItem.classList.remove('is-open');
            var siblingBtn = openItem.querySelector('.faq-question');
            var siblingAnswer = openItem.querySelector('.faq-answer');
            if (siblingBtn) siblingBtn.setAttribute('aria-expanded', 'false');
            if (siblingAnswer) siblingAnswer.style.maxHeight = '0px';
          });
        }

        if (isOpen) {
          item.classList.remove('is-open');
          btn.setAttribute('aria-expanded', 'false');
          if (answer) answer.style.maxHeight = '0px';
        } else {
          item.classList.add('is-open');
          btn.setAttribute('aria-expanded', 'true');
          if (answer && inner) answer.style.maxHeight = inner.scrollHeight + 'px';
        }
      });
    });
  }

  function initDetailToggles() {
    toArray(document.querySelectorAll('.product-detail-toggle')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('.product-detail-item');
        if (!item) return;

        var content = item.querySelector('.product-detail-content');
        var inner = item.querySelector('.product-detail-content-inner');
        var isOpen = item.classList.contains('is-open');

        item.classList.toggle('is-open', !isOpen);
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (content && inner) {
          content.style.maxHeight = isOpen ? '0px' : inner.scrollHeight + 'px';
        }
      });
    });
  }

  function initQuantity() {
    function syncPresetFromInput(input) {
      var scope = input.closest('form, .buy-info, .product-info');
      if (!scope) return;
      var value = parseInt(input.value, 10);
      var group = scope.querySelector('.quantity-presets');
      if (!group) return;
      toArray(group.querySelectorAll('[data-quantity-preset]')).forEach(function (preset) {
        preset.classList.toggle('is-active', parseInt(preset.getAttribute('data-quantity-preset'), 10) === value);
      });
    }

    toArray(document.querySelectorAll('.quantity-btn--minus')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('.quantity-input');
        if (!input) return;
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = 1;
        if (value > 1) input.value = value - 1;
        syncPresetFromInput(input);
      });
    });

    toArray(document.querySelectorAll('.quantity-btn--plus')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var input = btn.parentNode.querySelector('.quantity-input');
        if (!input) return;
        var value = parseInt(input.value, 10);
        if (isNaN(value)) value = 1;
        input.value = value + 1;
        syncPresetFromInput(input);
      });
    });

    toArray(document.querySelectorAll('.quantity-input[name="quantity"]')).forEach(function (input) {
      input.addEventListener('change', function () {
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < 1) value = 1;
        input.value = value;
        syncPresetFromInput(input);
      });
    });
  }

  function initQuantityPresets() {
    toArray(document.querySelectorAll('[data-quantity-preset]')).forEach(function (btn) {
      btn.addEventListener('click', function () {
        var value = parseInt(btn.getAttribute('data-quantity-preset'), 10);
        if (isNaN(value) || value < 1) return;

        var scope = btn.closest('form, .buy-info, .product-info') || document;
        var input = scope.querySelector('.quantity-input[name="quantity"], input[name="quantity"]');
        if (input) input.value = value;

        var group = btn.closest('.quantity-presets');
        if (group) {
          toArray(group.querySelectorAll('[data-quantity-preset]')).forEach(function (other) {
            other.classList.toggle('is-active', other === btn);
          });
        }
      });
    });
  }

  function updateCartCount(count) {
    toArray(document.querySelectorAll('.cart-count')).forEach(function (el) {
      el.textContent = String(count);
    });
  }

  function refreshCartCount() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
      })
      .catch(function () {});
  }

  function getCartDrawer() {
    return document.querySelector('[data-cart-drawer]');
  }

  function openCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;
    lastFocusedBeforeDrawer = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('no-scroll');
    document.body.classList.add('no-scroll');

    var panel = drawer.querySelector('.cart-drawer__panel');
    if (panel) panel.focus();
  }

  function closeCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('no-scroll');
    document.body.classList.remove('no-scroll');
    if (lastFocusedBeforeDrawer && typeof lastFocusedBeforeDrawer.focus === 'function') {
      lastFocusedBeforeDrawer.focus();
    }
  }

  function trapCartDrawerFocus(event, drawer) {
    if (event.key !== 'Tab' || !drawer.classList.contains('is-open')) return;
    var focusable = toArray(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'))
      .filter(function (el) { return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length); });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function renderCartDrawer(cart) {
    var drawer = getCartDrawer();
    if (!drawer || !cart) return;

    var body = drawer.querySelector('[data-cart-drawer-body]');
    var subtotal = drawer.querySelector('[data-cart-drawer-subtotal]');
    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
    if (!body) return;

    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<p class="cart-drawer__empty">Your cart is empty.</p>';
      return;
    }

    body.innerHTML = cart.items.map(function (item) {
      var image = item.image ? '<img src="' + escapeHTML(item.image) + '" alt="' + escapeHTML(item.product_title) + '" loading="lazy">' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cart-drawer-item__variant">' + escapeHTML(item.variant_title) + '</p>' : '';
      return [
        '<article class="cart-drawer-item">',
          '<a class="cart-drawer-item__image" href="' + escapeHTML(item.url) + '">' + image + '</a>',
          '<div>',
            '<p class="cart-drawer-item__title"><a href="' + escapeHTML(item.url) + '">' + escapeHTML(item.product_title) + '</a></p>',
            variant,
            '<p class="cart-drawer-item__price">' + formatMoney(item.final_line_price) + '</p>',
            '<div class="cart-drawer-item__controls">',
              '<div class="quantity-selector">',
                '<button type="button" class="quantity-btn" data-cart-change="' + escapeHTML(item.key) + '" data-cart-quantity="' + Math.max(0, item.quantity - 1) + '" aria-label="Decrease quantity">-</button>',
                '<span class="quantity-input" aria-label="Quantity">' + item.quantity + '</span>',
                '<button type="button" class="quantity-btn" data-cart-change="' + escapeHTML(item.key) + '" data-cart-quantity="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>',
              '</div>',
              '<button type="button" class="cart-drawer-item__remove" data-cart-change="' + escapeHTML(item.key) + '" data-cart-quantity="0">Remove</button>',
            '</div>',
          '</div>',
        '</article>'
      ].join('');
    }).join('');
  }

  function refreshCartDrawer(shouldOpen) {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
        renderCartDrawer(cart);
        if (shouldOpen) openCartDrawer();
      })
      .catch(function () {});
  }

  function changeCartItem(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-change-failed');
        return res.json();
      })
      .then(function (cart) {
        updateCartCount(cart.item_count || 0);
        renderCartDrawer(cart);
      })
      .catch(function () {});
  }

  function initCartDrawer() {
    var drawer = getCartDrawer();
    if (!drawer) return;

    toArray(drawer.querySelectorAll('[data-cart-drawer-close]')).forEach(function (trigger) {
      trigger.addEventListener('click', closeCartDrawer);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) closeCartDrawer();
      trapCartDrawerFocus(event, drawer);
    });

    drawer.addEventListener('click', function (event) {
      var change = event.target.closest('[data-cart-change]');
      if (!change) return;
      event.preventDefault();
      var key = change.getAttribute('data-cart-change');
      var quantity = parseInt(change.getAttribute('data-cart-quantity'), 10);
      if (!key || isNaN(quantity)) return;
      changeCartItem(key, quantity);
    });

    toArray(document.querySelectorAll('[data-cart-toggle]')).forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        refreshCartDrawer(true);
      });
    });

  }

  function submitCartForm(form, submitBtn) {
    var button = submitBtn || form.querySelector('[type="submit"]');
    if (!button) return;

    var originalText = button.getAttribute('data-default-text') || button.textContent;
    button.disabled = true;
    button.textContent = 'ADDING...';

    var formData = new FormData(form);
    var variantId = formData.get('id');
    var qty = parseInt(formData.get('quantity'), 10);
    if (isNaN(qty) || qty < 1) qty = 1;

    if (!variantId) {
      button.textContent = 'SELECT PRODUCT';
      setTimeout(function () {
        button.textContent = originalText;
        button.disabled = false;
      }, 1400);
      return;
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({ id: variantId, quantity: qty })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('cart-add-failed');
        return res.json();
      })
      .then(function () {
        button.textContent = 'ADDED';
        refreshCartDrawer(true);
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1200);
      })
      .catch(function () {
        button.textContent = 'TRY AGAIN';
        setTimeout(function () {
          button.textContent = originalText;
          button.disabled = false;
        }, 1400);
      });
  }

  function initAjaxCartForms() {
    var selectors = ['#product-form', '[data-product-form]', '[data-quick-add-form]', '[data-sticky-atc-form]'];
    toArray(document.querySelectorAll(selectors.join(','))).forEach(function (form) {
      if (form.dataset.cartBound === 'true') return;
      form.dataset.cartBound = 'true';

      form.addEventListener('submit', function (event) {
        event.preventDefault();
        submitCartForm(form);
      });
    });
  }

  function bindGalleryRoot(root) {
    if (!root) return;
    var track = root.querySelector('[data-gallery]');
    var dots = toArray(root.querySelectorAll('.gallery-dot'));
    if (!track) return;

    function setDot(index) {
      dots.forEach(function (dot, dotIndex) {
        var active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
    }

    function syncFromScroll() {
      if (!dots.length) return;
      var width = track.clientWidth || 1;
      var index = Math.round(track.scrollLeft / width);
      setDot(index);
    }

    if (dots.length) {
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          track.scrollTo({ left: (track.clientWidth || 0) * index, behavior: 'smooth' });
          setDot(index);
        });
      });
    }

    track.addEventListener('scroll', function () {
      window.requestAnimationFrame(syncFromScroll);
    }, { passive: true });

    syncFromScroll();
  }

  function renderVariantGallery(galleryRoot, urls) {
    if (!galleryRoot || !urls || !urls.length) return;

    var track = galleryRoot.querySelector('[data-gallery]');
    var dots = galleryRoot.querySelector('.gallery-dots');
    if (!track) return;

    track.innerHTML = urls.map(function (url, idx) {
      return '<div class="gallery-slide"><img src="' + url + '" alt="Product image ' + (idx + 1) + '" loading="lazy"></div>';
    }).join('');

    if (dots) {
      dots.innerHTML = urls.map(function (_, idx) {
        var activeClass = idx === 0 ? ' is-active' : '';
        var selected = idx === 0 ? 'true' : 'false';
        return '<button class="gallery-dot' + activeClass + '" type="button" aria-label="Image ' + (idx + 1) + '" aria-selected="' + selected + '"></button>';
      }).join('');
    }

    track.scrollLeft = 0;
    bindGalleryRoot(galleryRoot);
  }

  function initGalleries() {
    toArray(document.querySelectorAll('[data-gallery-root], .buy-gallery, .product-gallery')).forEach(function (root) {
      if (root.dataset.galleryBound === 'true') return;
      root.dataset.galleryBound = 'true';
      bindGalleryRoot(root);
    });
  }

  function applyVariantToScopedInputs(scope, variantId) {
    if (!scope || !variantId) return;

    var hiddenInputs = toArray(scope.querySelectorAll('input[name="id"]'));
    hiddenInputs.forEach(function (input) {
      input.value = variantId;
    });

    var selects = toArray(scope.querySelectorAll('select[name="id"], [data-variant-select], #variant-select'));
    selects.forEach(function (select) {
      var found = false;
      for (var i = 0; i < select.options.length; i += 1) {
        if (String(select.options[i].value) === String(variantId)) {
          select.selectedIndex = i;
          found = true;
          break;
        }
      }
      if (!found && select.value !== undefined) select.value = variantId;
    });

    toArray(document.querySelectorAll('.sticky-mobile-atc input[name="id"]')).forEach(function (input) {
      input.value = variantId;
    });
  }

  function applyVariantToGallery(scope, variantId) {
    if (!scope || !variantId) return;

    var galleryCandidates = toArray(scope.querySelectorAll('[data-variant-gallery]'));
    if (!galleryCandidates.length) {
      galleryCandidates = toArray(document.querySelectorAll('[data-variant-gallery]'));
    }

    galleryCandidates.forEach(function (galleryRoot) {
      var map = galleryRoot._variantMediaMap;
      if (!map) {
        map = parseJSON(galleryRoot.getAttribute('data-variant-media'), {});
        galleryRoot._variantMediaMap = map;
      }

      var urls = map[String(variantId)] || map[variantId];
      if (!urls || !urls.length) return;
      renderVariantGallery(galleryRoot, urls.slice(0, 3));
    });
  }

  function initVariantPicker() {
    toArray(document.querySelectorAll('.variant-picker')).forEach(function (picker) {
      var buttons = toArray(picker.querySelectorAll('.variant-option'));
      if (!buttons.length) return;

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (other) {
            other.classList.remove('is-active');
            other.setAttribute('aria-selected', 'false');
          });

          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');

          var variantName = btn.getAttribute('data-value') || '';
          var variantId = btn.getAttribute('data-variant-id');
          var variantPrice = btn.getAttribute('data-price');
          var variantAvailable = btn.getAttribute('data-available');

          var selectedName = picker.querySelector('.variant-selected-name');
          if (selectedName && variantName) selectedName.textContent = variantName;

          var scope = picker.closest('.buy-section, .product-section, section') || picker.closest('form') || document;
          if (variantId) {
            applyVariantToScopedInputs(scope, variantId);
            applyVariantToGallery(scope, variantId);
            if (scope.classList && scope.classList.contains('product-section') && window.history && window.history.replaceState) {
              var url = new URL(window.location.href);
              url.searchParams.set('variant', variantId);
              window.history.replaceState({}, '', url.toString());
            }
          }

          if (variantPrice) {
            toArray(scope.querySelectorAll('.buy-price, .current-price')).forEach(function (priceEl) {
              priceEl.textContent = variantPrice;
            });
            toArray(document.querySelectorAll('.sticky-atc-price')).forEach(function (priceEl) {
              priceEl.textContent = variantPrice;
            });
          }

          var buyButtons = toArray(scope.querySelectorAll('[data-add-to-cart], form button[type="submit"]'));
          if (variantAvailable === 'false') {
            buyButtons.forEach(function (button) {
              if (!button.classList.contains('btn--outline')) {
                button.disabled = true;
              }
            });
          } else if (variantAvailable === 'true') {
            buyButtons.forEach(function (button) {
              if (!button.classList.contains('btn--outline')) {
                button.disabled = false;
              }
            });
          }
        });
      });
    });
  }

  function initStickyATC() {
    var bar = document.querySelector('.sticky-mobile-atc');
    if (!bar) return;

    var target = document.querySelector('#buy, .product-section');

    function checkVisibility() {
      var y = window.scrollY || window.pageYOffset;
      var showAfter = 280;
      var shouldShow = y > showAfter;

      if (target) {
        var rect = target.getBoundingClientRect();
        var inView = rect.top < window.innerHeight && rect.bottom > 0;
        if (inView) shouldShow = false;
      }

      bar.classList.toggle('is-visible', shouldShow);
    }

    window.addEventListener('scroll', checkVisibility, { passive: true });
    checkVisibility();
  }

  function initVideoSoundToggles() {
    toArray(document.querySelectorAll('[data-video-sound-toggle]')).forEach(function (button) {
      if (button.dataset.videoToggleBound === 'true') return;
      button.dataset.videoToggleBound = 'true';

      var shell = button.closest('.chewlax-video__shell');
      var video = shell ? shell.querySelector('video') : null;
      if (!video) return;

      var mutedLabel = button.textContent || 'SOUND ON';
      var unmutedLabel = button.getAttribute('data-unmuted-label') || 'MUTE';

      button.addEventListener('click', function () {
        var shouldUnmute = video.muted;
        video.muted = !shouldUnmute;
        if (shouldUnmute) {
          video.play().catch(function () {});
        }
        button.setAttribute('aria-pressed', shouldUnmute ? 'true' : 'false');
        button.textContent = shouldUnmute ? unmutedLabel : mutedLabel;
      });
    });
  }

  function initSmoothScroll() {
    toArray(document.querySelectorAll('a[href^="#"]')).forEach(function (link) {
      link.addEventListener('click', function (event) {
        var href = link.getAttribute('href');
        if (!href || href === '#') return;
        var target = document.querySelector(href);
        if (!target) return;

        event.preventDefault();
        var styles = getComputedStyle(document.documentElement);
        var offset = parseInt(styles.getPropertyValue('--header-offset'), 10) || parseInt(styles.getPropertyValue('--header-h'), 10) || 72;
        var top = target.getBoundingClientRect().top + window.scrollY - offset - 10;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });
  }

  function initCampaignSlider() {
    toArray(document.querySelectorAll('[data-campaign-slider]')).forEach(function (slider) {
      var track = slider.querySelector('[data-slider-track]');
      var slides = toArray(slider.querySelectorAll('[data-slide]'));
      var dots = toArray(slider.querySelectorAll('[data-slider-dot]'));
      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');
      if (!track || slides.length < 2) return;

      var index = 0;
      var intervalId = null;
      var autoplay = slider.getAttribute('data-autoplay') === 'true';
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) autoplay = false;
      var interval = parseInt(slider.getAttribute('data-interval'), 10);
      if (isNaN(interval) || interval < 2500) interval = 5000;

      function render() {
        track.style.transform = 'translate3d(' + (-index * 100) + '%, 0, 0)';
        slides.forEach(function (slide, slideIndex) {
          slide.classList.toggle('is-active', slideIndex === index);
        });
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function goTo(nextIndex) {
        if (nextIndex < 0) nextIndex = slides.length - 1;
        if (nextIndex >= slides.length) nextIndex = 0;
        index = nextIndex;
        render();
      }

      function startAutoplay() {
        if (!autoplay) return;
        stopAutoplay();
        intervalId = window.setInterval(function () {
          goTo(index + 1);
        }, interval);
      }

      function stopAutoplay() {
        if (intervalId) {
          window.clearInterval(intervalId);
          intervalId = null;
        }
      }

      if (prev) {
        prev.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(index - 1);
          startAutoplay();
        });
      }

      if (next) {
        next.addEventListener('click', function (event) {
          event.preventDefault();
          goTo(index + 1);
          startAutoplay();
        });
      }

      dots.forEach(function (dot) {
        dot.addEventListener('click', function () {
          var dotIndex = parseInt(dot.getAttribute('data-slider-dot'), 10);
          if (isNaN(dotIndex)) return;
          goTo(dotIndex);
          startAutoplay();
        });
      });

      var startX = 0;
      var moveX = 0;
      track.addEventListener('touchstart', function (event) {
        if (!event.touches || !event.touches.length) return;
        startX = event.touches[0].clientX;
        moveX = 0;
      }, { passive: true });

      track.addEventListener('touchmove', function (event) {
        if (!event.touches || !event.touches.length) return;
        moveX = event.touches[0].clientX - startX;
      }, { passive: true });

      track.addEventListener('touchend', function () {
        if (Math.abs(moveX) > 45) {
          if (moveX < 0) goTo(index + 1);
          else goTo(index - 1);
          startAutoplay();
        }
      });

      slider.addEventListener('mouseenter', stopAutoplay);
      slider.addEventListener('mouseleave', startAutoplay);

      render();
      startAutoplay();
    });
  }

  function initTestimonialSlider() {
    toArray(document.querySelectorAll('[data-testimonials-slider]')).forEach(function (section) {
      var track = section.querySelector('[data-testimonials-track]');
      var dots = toArray(section.querySelectorAll('[data-testimonial-dot]'));
      if (!track || !dots.length) return;

      function setActive(index) {
        dots.forEach(function (dot, dotIndex) {
          var active = dotIndex === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      dots.forEach(function (dot, idx) {
        dot.addEventListener('click', function () {
          var cards = toArray(track.children);
          if (!cards[idx]) return;
          track.scrollTo({ left: cards[idx].offsetLeft, behavior: 'smooth' });
          setActive(idx);
        });
      });

      track.addEventListener('scroll', function () {
        if (window.innerWidth >= 768) return;
        var width = track.clientWidth || 1;
        var index = Math.round(track.scrollLeft / width);
        setActive(index);
      }, { passive: true });

      setActive(0);
    });
  }

  function init() {
    initReveal();
    initHeader();
    initMobileMenu();
    initFAQ();
    initDetailToggles();
    initQuantity();
    initQuantityPresets();
    initCartDrawer();
    initAjaxCartForms();
    initVariantPicker();
    initVideoSoundToggles();
    initCampaignSlider();
    initGalleries();
    initTestimonialSlider();
    initStickyATC();
    initSmoothScroll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
